<template>
  <Dropdown
    :sideOffset="8"
    :align="'end'"
    @update:open="$emit('update:open', $event)"
  >
    <slot />
    <template #content>
      <div class="w-[200px]">
        <div class="text-secondary text-style-sm font-medium px-4 py-3">
          {{ $t("components.data_grid.column_options") }}
        </div>
        <Divider orientation="horizontal" class="w-full pb-1.5" />
        <div ref="columnsList" class="flex flex-col">
          <div
            v-for="filter in filters"
            :key="filter.value"
            :data-value="filter.value"
            class="py-px px-1.5"
          >
            <div class="flex flex-row items-center px-2.5 py-[9px]">
              <Icon
                name="menu-grid"
                class="drag-handle fg-senary cursor-ns-resize mr-3"
              />
              <Checkbox
                v-model:checked="filter.selected"
                @update:checked="handleUpdateSelection"
                class="mr-2"
                size="sm"
              />
              <div class="grow text-style-sm font-medium text-secondary">
                {{ filter.label }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
  </Dropdown>
</template>
<script setup>
// Import Vue Utilities
import { onUpdated, ref } from "vue";

// Import Utilities
import Sortable from "sortablejs";

// Import Components
import { Dropdown } from "@/SharedComponents/Dropdown";
import { Divider } from "@/SharedComponents/Divider";
import { Checkbox } from "@/SharedComponents/Checkboxes";
import { Icon } from "@/SharedComponents/Icon";

// Emits
const emit = defineEmits(["update:selection", "update:open"]);

// Define Props
const props = defineProps({
  open: {
    type: Boolean,
    required: true,
  },
  columns: {
    type: Array,
    required: true,
  },
  selectedColumns: {
    type: Array,
    required: true,
  },
});

// Refs
const columnsList = ref(null);

const filters = ref(
  props.columns
    .map((column) => {
      return {
        label: column.props.label,
        value: column.props.field,
        selected: props.selectedColumns.includes(column.props.field),
      };
    })
    .sort((a, b) => {
      return Number(b.selected) - Number(a.selected);
    })
);

// Functions
const handleUpdateSelection = () => {
  emit(
    "update:selection",
    filters.value
      .filter((option) => option.selected)
      .map((option) => option.value)
  );
};

// Lifecycle Hooks
onUpdated(() => {
  if (columnsList.value)
    new Sortable(columnsList.value, {
      handle: ".drag-handle",
      animation: 150,
      onUpdate: function (event) {
        const sortBy = Array.from(event.to.children).map((child) => {
          return child.dataset.value;
        });
        filters.value.sort((a, b) => {
          return sortBy.indexOf(a.value) - sortBy.indexOf(b.value);
        });
        handleUpdateSelection();
      },
    });
});
</script>
